import { filter } from '../helpers/filter';

import contactImg from '../images/sabrina_results.png';

const botName = "Isa"
const helloIcon = "🙋‍♀️"
const contactLink = "https://www.territory-influence.com/de/kontakt/"
const imprintLink = "https://www.territory-influence.com/en/imprint/"
const termsLink = "https://www.territory-influence.com/de/nutzungsbedingungen/"
const privacyLink = "https://www.territory-influence.com/de/datenschutzerklaerung/"

const infTypes = {
  "nano": {
    "short": "Nano",
    "long": "Nano Influencer",
  },
  "micro": {
    "short": "Micro",
    "long": "Micro Influencer",
  },
  "macro": {
    "short": "Macro",
    "long": "Macro Influencer",
  },
  "star": {
    "short": "Star",
    "long": "Star Influencer",
  },
}

const goalTypes = {
  "wom": {
    "title": "Weiterempfehlungen",
    "description": `Persönliche Weiterempfehlungen (oder Word-of-Mouth/WOM) zwischen Konsumenten werden durch Nano Influencer getriggert. Bei TERRITORY Influence greifen wir dabei auf einen Pool aus über 4 Mio. Influencern in Europa zurück, die wir passgenau zu Deiner Zielgruppe selektieren.`,
  },
  "insights": {
    "title": "Consumer Insights",
    "description": `Über Nano Influencer auf unseren Plattformen sammeln wir in kürzester Zeit Feedback zu Deinem Produkt oder Deiner Marke. Ob von 100 oder 10.000 Konsumenten - unsere Nano Influencer lieben es Dich mit ihrer Meinung zu unterstützen.`,
  },
  "posTraffic": {
    "title": "POS Traffic",
    "description": `Ausgestattet mit umfangreichen Hintergrundinformationen setzen wir Nano Influencer dazu ein, Traffic an Deinem POS zu erzeugen. Ob offline oder online: sie besuchen gemeinsam mit Freunden Deinen Shop und sorgen so für zusätzliche Umsätze und neue Kunden.`,
  },
  "premiumTrials": {
    "title": "Premium Trials",
    "description": `Durch den zielgerichteten Einsatz von Nano Influencern erzeugen wir relevante Produkterfahrungen mit hohem Zielgruppen-Fit. Nano Influencer wissen nämlich genau, für wen aus ihrem Umfeld ein Produkt geeignet ist und erzeugen somit Trial mit geringem Streuverlust und hohem Mehrwert.`,
  },
  "ratings": {
    "title": "Ratings & Reviews",
    "description": `Ob im e-Commerce oder auf Produktbewertungsseiten - authentische Ratings & Reviews von echten Konsumenten wirken sich positiv auf die Kaufentscheidung aus. Aus über 2.000 Kampagnen wissen wir: Nano Influencer eignen sich hierfür am besten.`,
  },
  "authContent": {
    "title": "Authentischer Content",
    "description": `Vor allem Nano und Micro Influencer sind unsere erste Wahl wenn Du authentischen Content im Social Web brauchst. Bei Bedarf kannst Du die generierten Content Pieces lizenzieren und auf Deinen eigenen Kanälen einsetzen.`,
  },
  "engagement": {
    "title": "Engagement",
    "description": `Micro und Macro Influencer glänzen durch die Nähe zu ihren Followern in Social Media durch besonders hohe Engagement-Raten. Deshalb sind sie erste Wahl wenn Dein Ziel Engagement ist.`,
  },
  "onlineReach": {
    "title": "Online Reach",
    "description": `Relevante Online Reichweiten lassen sich am besten über verschiedene Influencer-Kombinationen erzielen. Ob ein einzelner Star Influencer oder mehrere tausend Nano Influencer - eine sinvolle Strategie ist hier va. von Deinen anderen Zielen, Zielgruppe oder Branche abhängig.`,
  },
  "websiteTraffic": {
    "title": "Website Traffic",
    "description": `Über den gezielten Einsatz von Macro oder Star Influencern erzeugen wir zusätzlichen Traffic auf Deinen Websites.`,
  },
  "profContent": {
    "title": "Professioneller Content",
    "description": `Durch die Nähe zu ihren Themen und Spezialgebieten empfehlen wir Macro Influencer für die Produktion von professionellem Content.`,
  },
  "productStaging": {
    "title": "Produkt-Inszenierung",
    "description": `Produkt-Inszenierung ist die Stärke von Macro und Star Influencern. Durch ihr professionelles Know-How und ihre Erfahrung wissen sie, wie sich Produkte und Marken gekonnt in Szene setzen lassen und produzieren dadurch hochwertigen Content.`,
  },
  "storytelling": {
    "title": "Thematisches Storytelling",
    "description": `Macro Influencer sind in definierten Kategorien zu Hause und somit Experten in ihrem Fachgebiet. Storytelling rund um ein bestimmtes Thema funktioniert mit ihnen daher besonders gut.`,
  },
  "imageShaping": {
    "title": "Image Shaping",
    "description": `Image Shaping ist die Stärke von Star Influencern. Diese, einer sehr breiten Zielgruppe bekannten, Persönlichkeiten schaffen es, ihr eigenes Image und ihre eigene positive Strahlkraft auf Deine Marke oder Dein Produkt zu übertragen.`,
  },
  "testimonials": {
    "title": "Testimonials",
    "description": `Testimonials finden wir bei den Star Influencern. Die richtige Strategie hängt bei diesem Punkt stark von Deinen anderen Zielen und Deinen persönlichen Präferenzen ab.`,
  },
  "awareness": {
    "title": "Awareness",
    "description": `Awareness können wir über alle Influencer-Kategorien erzeugen. Letztendlich sind hier Deine persönlichen Präferenzen und die Gesamtstrategie Deiner Influencer-Aktion ausschlaggebend.`,
  },
  "sampling": {
    "title": "Sampling",
    "description": `Durch den Zugriff auf über 4 Mio. Influencer in ganz Europa können wir zielgerichtete Sampling-Aktionen durchführen und setzen dabei auf Nano, Micro, Macro oder Star Influencer.`,
  },
  "education": {
    "title": "Education",
    "description": `Komplexe bzw. erklärungsbedürftige Produkte sind ideal für den Einsatz von Nano, Micro oder aber auch Macro Influencern. Diese können bspw. im persönlichen Gespräch oder über Tutorials komplexe Produkteigenschaften ihrem Umfeld näherbringen.`,
  },
}

const welcomeScreen = {
  "h1": "Durchblick für Ihre Influencer-Strategie!",
  "h2": "Die richtige Influencer-Strategie zu finden ist nicht einfach. Unser datenbasierter Quick-Check hilft Ihnen in wenigen Minuten zu einer ersten Einschätzung einer passenden Strategie für Ihre Marke und Ihr Produkt!",
  "button": "Check starten",
}

const appLoader = {
  "initializing": "Initialisiere App",
  "waking": "Wecke Assistent",
  "ready": "Los geht's!",
}

export const de = (data) => {

  const { product, industries, goals, recommendation } = data
  const filteredProduct = filter.clean(product)
  const topOne = recommendation.topOne.length > 0 && infTypes[recommendation.topOne]
  const topTwo = recommendation.topTwo.length > 0 && infTypes[recommendation.topTwo]

  return {
    botName,
    helloIcon,
    welcomeScreen,
    appLoader,
    "botMessages": {
      "m1": {
        "comment": `Hi! Ich bin ${botName}, Deine virtuelle Assistentin. ${helloIcon} Ich helfe Dir, die richtige Influencer-Strategie für Dein Produkt oder Deine Marke zu finden.`,
      },
      "m2": {
        "comment": "Am besten, wir lernen uns kurz kennen. Los geht's ...",
        "question": "Bei welchem Unternehmen arbeitest Du?",
      },
      "m4": {
        "comment": "Wunderbar! Diese Information hilft mir, Dein Ergebnis noch besser zu personalisieren. 😊",
      },
      "m5": {
        "comment": "Weiter geht's ...",
        "question": "Für welches Produkt oder welche Marke möchtest Du Influencer einsetzen?",
      },
      "m7": {
        "comment": "Sehr schön.",
        "question": `Welche Ziele verfolgst Du mit einer Influencer-Kampagne für "${filteredProduct}"?`,
      },
      "m91": {
        "comment": "Hm ...",
        "question": "Ganz schön viele Ziele. Hier würde eine persönliche Beratung jetzt mehr Sinn machen!",
        "addon": "Alternativ kannst Du auch die Anzahl Deiner Ziele auf max. 4 reduzieren ...",
        "button": "Beratung anfordern",
        "contactLink": contactLink,
      },
      "m92": {
        "comment": "Okay.",
        "question": `Zu welcher Produktkategorie gehört "${filteredProduct}"?`,
        "addon": "Bitte wähle max. 2 Produktkategorien ...",
      },
      "m11": {
        "comment": "Wir haben es gleich geschafft. Nur noch zwei kurze Fragen zur Zielgruppe ...",
        "question": `Wie alt ist die Zielgruppe für "${filteredProduct}"?`,
        "addon": "Bitte wähle alle Altersklassen, die zutreffen ...",
      },
      "m13": {
        "question": "Und das Geschlecht?",
      },
      "m15": {
        "comment": "Großartig! Jetzt wären wir soweit fertig. Es sei denn, Du möchtest mir sonst noch etwas mitteilen ...",
        "question": "Gibt es sonst noch etwas, das ich wissen sollte?",
        "addon": "Bspw. zu den Zielen, dem Produkt oder der Zielgruppe ...",
      },
      "m17": {
        "comment": "Freut mich. Ich unterhalte mich gerne mit Dir! 😊",
        "question": "Was möchtest Du mir noch mitteilen?",
      },
      "m1000": {
        "comment": "Alles klar. Ich berechne jetzt Dein Ergebnis ...",
      },
      "m1001": {
        "comment": "Ok, fertig! 💪",
        "question": "Hier eine erste Einschätzung auf Basis Deines Briefings:",
      },
    },
    "inputs": {
      "goals": {
        "wom": goalTypes.wom.title,
        "insights": goalTypes.insights.title,
        "posTraffic": goalTypes.posTraffic.title,
        "premiumTrials": goalTypes.premiumTrials.title,
        "ratings": goalTypes.ratings.title,
        "authContent": goalTypes.authContent.title,
        "engagement": goalTypes.engagement.title,
        "onlineReach": goalTypes.onlineReach.title,
        "websiteTraffic": goalTypes.websiteTraffic.title,
        "profContent": goalTypes.profContent.title,
        "productStaging": goalTypes.productStaging.title,
        "storytelling": goalTypes.storytelling.title,
        "imageShaping": goalTypes.imageShaping.title,
        "testimonials": goalTypes.testimonials.title,
        "awareness": goalTypes.awareness.title,
        "sampling": goalTypes.sampling.title,
        "education": goalTypes.education.title,
      },
      "industries": {
        "beauty": "Beauty",
        "automotive": "Automotive",
        "travel": "Travel",
        "pharma": "Pharma",
        "tech": "Technik",
        "eCom": "eCommerce",
        "fashion": "Mode",
        "foodBev": "Essen & Getränke",
        "household": "Haushalt",
        "finance": "Finanzen & Versicherungen",
        "games": "Spielwaren",
        "energy": "Energie",
        "other": "Sonstige",
      },
      "ageRanges": {
        "1to5": "1 - 5",
        "6to12": "6 - 12",
        "13to18": "13 - 18",
        "19to24": "19 - 24",
        "25to34": "25 - 34",
        "35to44": "35 - 44",
        "45to54": "45 - 54",
        "55to64": "55 - 64",
        "65plus": "65+",
      },
      "gender": {
        "male": "Männlich",
        "female": "Weiblich",
      },
      "else": {
        "yes": "Ja",
        "no": "Nein",
      },
      "buttons": {
        "confirm": "Bestätigen",
      },
    },
    "results": {
      "h1": `Meine Empfehlung für ${filteredProduct}`,
      "h2": {
        "single": `Dein individuelles Briefing spricht für eine Strategie mit Fokus auf ${topOne.long}.`,
        "multiple": `Dein individuelles Briefing spricht für eine Strategie mit Fokus auf ${topOne.short} und ${topTwo.long}.`,
      },
      "infTypes": {
        "nano": {
          "title": infTypes.nano.long,
          "description": `${infTypes.nano.long} sind begeisterte Konsumenten, die glaubwürdige Empfehlungen in ihrem Umfeld durch persönliche Gespräche, gemeinsame Produkterfahrungen und Beiträge in sozialen Netzwerken verbreiten.`,
        },
        "micro": {
          "title": infTypes.micro.long,
          "description": `${infTypes.micro.long} sind Markenbotschafter mit 1.000 - 100.000 Followern, die durch authentische Social Content und hohes Engagement organische Online-Reichweiten generieren.`,
        },
        "macro": {
          "title": infTypes.macro.long,
          "description": `${infTypes.macro.long} sind Content Creator mit mehr als 100.000 Followern, die mit hochwertigen Inhalten ein breites Publikum ansprechen und so Imageeffekte für Marken und Produkte erzeugen.`,
        },
        "star": {
          "title": infTypes.star.long,
          "description": `${infTypes.star.long} sind Testimonials mit einem breiten persönlichen Social-Media-Publikum, die auch außerhalb von Social Media prominent sind und so ein hohes Maß an Markenbekanntheit und Produktattraktivität schaffen.`,
        },
      },
      "hint": "Bitte beachte, dass meine Empfehlung lediglich eine erste Einschätzung auf Basis Deiner eingegebenen Daten darstellt und eine persönliche Beratung nicht ersetzt. Je nachdem, wie Du bspw. Deine Ziele gewichtest oder wie viel Budget Du zur Verfügung hast kann auch eine andere Strategie sinnvoll sein.",

      "background": {
        "headline": "Hintergründe zu der Empfehlung",
        "description": "Bei der Konzeption von Influencer-Kampagnen stehen Deine Bedürfnisse klar im Fokus. Deine individuellen Ziele, Branche und Zielgruppe spielen dabei eine zentrale Rolle. Im Folgenden erläutere ich Dir, wie diese Faktoren Dein Analyse-Ergebnis beeinflussen.",
        "basis": {
          "headline": "Dein Briefing als Basis",
          "product": "Produkt/Marke:",
          "goals": goals.length > 1 ? "Ziele:" : "Ziel:",
          "industries": industries.length > 1 ? "Branchen:" : "Branche:",
          "target": "Zielgruppe:",
          "other": "Sonstiges:",
          "helpers": {
            "male": "Männer",
            "female": "Frauen",
            "and": "und",
            "years": "Jahre",
            "allRanges": "in allen Altersklassen",
            "multipleRanges": "in den Altersklassen",
            "singleRange": "in der Altersklasse",
          },
        },
        "goals": {
          "headline": goals.length > 1 ? "Ziele" : "Ziel",
          "wom": goalTypes.wom.description,
          "insights": goalTypes.insights.description,
          "posTraffic": goalTypes.posTraffic.description,
          "premiumTrials": goalTypes.premiumTrials.description,
          "ratings": goalTypes.ratings.description,
          "authContent": goalTypes.authContent.description,
          "engagement": goalTypes.engagement.description,
          "onlineReach": goalTypes.onlineReach.description,
          "websiteTraffic": goalTypes.websiteTraffic.description,
          "profContent": goalTypes.profContent.description,
          "productStaging": goalTypes.productStaging.description,
          "storytelling": goalTypes.storytelling.description,
          "imageShaping": goalTypes.imageShaping.description,
          "testimonials": goalTypes.testimonials.description,
          "awareness": goalTypes.awareness.description,
          "sampling": goalTypes.sampling.description,
          "education": goalTypes.education.description,
        },
      },
    },
    "contact": {
      "h1": "Mehr erfahren",
      "p": "Meine Kollegen sprechen gerne persönlich mit Dir, um Dir Deine optimale Strategie zu erläutern. Nenn mir einfach Deine Kotaktdaten und meine Kollegen melden sich umgehend.",
      "form": {
        "headline": "Deine Kontaktdaten",
        "optional": "optional",
        "button": "Senden",
        "legal": "Die durch mich getätigten Angaben werden, wenn ich auf „Senden“ klicke, durch Territory Influence zum Zweck der Kontaktaufnahme betreffend einer möglichen Zusammenarbeit genutzt. Territory Influence nutzt den Google-Dienst Firebase. Nähere Informationen zur Speicherung und Nutzung meiner angegebenen personenbezogenen Daten durch Territory Influence sowie zum Einsatz von Firebase kann ich der Datenschutzerklärung entnehmen.",
      },
      "mail": "beratung@territory.group",
      "phone": "+49 (0) 89 307 668 0",
    },
    "thankYou": {
      "h1": "Vielen Dank! Wir melden uns umgehend.",
      "h3": "Wenn Du möchtest kannst Du Dich auch direkt an meine Kollegin Sabrina wenden!",
      "phone": "+49 (0) 40 370 339 98",
      "mail": "prumbs.sabrina@territory.group",
      "image": contactImg,
    },
    "error": {
      "h1": "Ups ...",
      "h3": "Irgendetwas ist schief gelaufen.",
      "contact": "Kontaktiere uns am besten direkt:",
      "button": "Jetzt Kontakt aufnehmen",
      "contactLink": contactLink,
    },
    "legalBox": {
      "imprint": {
        "title": "Impressum",
        "link": imprintLink,
      },
      "terms": {
        "title": "Nutzungsbedingungen",
        "link": termsLink,
      },
      "privacy": {
        "title": "Datenschutzerklärung",
        "link": privacyLink,
      },
    },
    "placeholders": {
      "companyName": "Unternehmensname oder -URL ...",
      "productName": "Produkt- oder Markenname ...",
      "other": "Bitte Nachricht eingeben ...",
    }
  }
}
